export const DOCUMENT_INTERACTION = 'documentInteraction';
export const INDEX_HOVER_ACTION_INTERACTION = 'indexHoverActionInteraction';
export const UPLOAD_FILE_INTERACTION = 'uploadFileInteraction';
export const DOCUMENT_DESCRIPTION_INTERACTION = 'documentDescriptionInteraction';